import React, { useState } from 'react';
import { router } from '@inertiajs/react';
import { TemperatureGraphDialog } from '../../../components/order/TemperatureGraphDialog';
import Glyph from '../../../components/Glyph';
import { useTrans } from '../../../hooks/useTrans';
import { trackAndTraceUrl } from '../../../lib/routes';

function ReportForm({ traceUuid, good }) {
    const action = good
        ? `/api/temperature/report/generate/${traceUuid}?good_id=${good.id}`
        : `/api/temperature/report/generate/${traceUuid}`;

    return (
        <form action={action} method="post">
            <button type="submit" className="button button--clear button--base button--icon">
                <Glyph name="glyph-download" />
            </button>
        </form>
    );
}

export default function GoodsList({ goods, activeGoodId, traceUuid, fromOrderId, temperature, isAuthenticated }) {
    const translate = useTrans();
    const [chartGoodId, setChartGoodId] = useState(null);

    return (
        <>
            <table className="table table--is-goods-table">
                <thead>
                    <tr>
                        <th>{translate('Type')}</th>
                        <th>{translate('Status')}</th>
                        <th>
                            {isAuthenticated && temperature.showReporting && temperature.hasReporting && (
                                <ReportForm traceUuid={traceUuid} />
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {goods.map((good) => (
                        <tr
                            key={good.id}
                            className={`table-row--clickable ${good.id === activeGoodId ? 'is-selected' : ''}`}
                            onClick={() => router.get(trackAndTraceUrl(traceUuid, { goodId: good.id, fromOrderId }), {}, { preserveScroll: true })}
                        >
                            <td>
                                <div className="order-type">
                                    <Glyph name="glyph-package" className="glyph-package--table" />
                                    <span className="order-type__data">{good.amount}x {good.type},&nbsp;</span>
                                    {good.weight > 0 && good.dimensions && (
                                        <span className="order-detail">{good.weight} kg, {good.dimensions}</span>
                                    )}
                                </div>

                                {good.description && (
                                    <div className="order-details">
                                        <span className="order-detail">{good.description}</span>
                                    </div>
                                )}

                                <div className="order-details">
                                    <span className="order-type__data">
                                        {good.stackable && <span className="order-detail order-detail--small">{translate('Stapelbaar')}</span>}
                                        {good.fragile && <span className="order-detail order-detail--small">{translate('Breekbaar')}</span>}
                                    </span>
                                </div>

                                {good.barcode && (
                                    <div className="order-type">
                                        <div className="order-details__row">
                                            <div className="flex flex--align-center">
                                                <Glyph name="glyph-barcode" className="glyph-package--table" />
                                                <span>{good.barcode}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="order-type">
                                    <div className="order-details__row">
                                        <div className="flex flex--align-center">
                                            {! isAuthenticated && good.hasTemperatureReporting && temperature.showLoginLinkForGuests && (
                                                <span>
                                                    <a href="/login">{translate('Log in om temperatuurrapportages te bekijken.')}</a>
                                                </span>
                                            )}
                                            {isAuthenticated && good.currentTemperature && good.hasTemperatureReporting && (
                                                <>
                                                    <Glyph name="glyph-temperature" />
                                                    <span>{good.currentTemperature} &#8451;</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span className="order-title">{good.status.title}</span>
                                <span className="order-date order-date--regular">{good.status.date} {translate('uur')}</span>
                            </td>
                            <th onClick={(event) => event.stopPropagation()}>
                                <div className="flex flex--gap-5">
                                    {isAuthenticated && good.hasTemperatureReporting && (
                                        <>
                                            <ReportForm traceUuid={traceUuid} good={good} />

                                            <button
                                                type="button"
                                                onClick={() => setChartGoodId(good.id)}
                                                title={translate('Temperatuurverloop')}
                                                className="button button--clear button--base button--icon"
                                            >
                                                <Glyph name="glyph-show-graph" />
                                            </button>
                                        </>
                                    )}
                                </div>
                            </th>
                        </tr>
                    ))}
                </tbody>
            </table>

            <TemperatureGraphDialog
                open={chartGoodId !== null}
                onOpenChange={(open) => setChartGoodId(open ? chartGoodId : null)}
                traceUuid={traceUuid}
                goodId={chartGoodId}
            />
        </>
    );
}
